const localStorageKey = '__authenticated__'

export async function getToken() {
  // if we were a real auth provider, this is where we would make a request
  // to retrieve the user's token. (It's a bit more complicated than that...
  // but you're probably not an auth provider so you don't need to worry about it).
  return window.localStorage.getItem(localStorageKey)
}

function handleUserResponse({ username }) {
  window.localStorage.setItem(localStorageKey, username)
  return username
}

export async function login({ username, password }) {
  const result = await client('login', { username, password })
  return handleUserResponse(result)
}

export async function logout() {
  window.localStorage.removeItem(localStorageKey)
  await client('logout')
}

// an auth provider wouldn't use your client, they'd have their own
// so that's why we're not just re-using the client
const authURL = process.env.REACT_APP_AUTH_URL || '/api'

async function client(endPoint, data) {
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    headers: data ? { 'Content-Type': 'application/json' } : undefined,
  }

  return window.fetch(`${authURL}/${endPoint}`, config).then(async response => {
    const data = await response.json()
    if (response.ok) {
      return data
    } else {
      return Promise.reject(data)
    }
  })
}
